import { render, staticRenderFns } from "./MarcacaoVincularAutorizacao.vue?vue&type=template&id=389fd1e9&"
import script from "./MarcacaoVincularAutorizacao.vue?vue&type=script&lang=js&"
export * from "./MarcacaoVincularAutorizacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports